import { render, staticRenderFns } from "./PsPatientPaymentDetail.vue?vue&type=template&id=359e5559&scoped=true&"
import script from "./PsPatientPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientPaymentDetail.vue?vue&type=style&index=0&id=359e5559&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359e5559",
  null
  
)

export default component.exports